import { en } from "./en";
import { ru } from "./ru";
const catalogs = { ru, en };
function getLeaf(tree, parts) {
    let cur = tree;
    for (const p of parts) {
        if (cur === null || cur === undefined || typeof cur !== "object")
            return undefined;
        cur = cur[p];
    }
    return typeof cur === "string" ? cur : undefined;
}
export function translate(lang, key, params) {
    const parts = key.split(".");
    let text = getLeaf(catalogs[lang], parts);
    if (text === undefined) {
        text = getLeaf(ru, parts) ?? key;
    }
    if (params) {
        for (const [k, v] of Object.entries(params)) {
            text = text.replace(new RegExp(`\\{\\{${k.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\}\\}`, "g"), String(v));
        }
    }
    return text;
}
export function modeLabel(lang, mode) {
    return translate(lang, mode === "sandbox" ? "mode.sandbox" : "mode.live");
}
